import { render, staticRenderFns } from "./WindowBar.vue?vue&type=template&id=03a63c48&"
import script from "./WindowBar.vue?vue&type=script&lang=js&"
export * from "./WindowBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports